(ns ycweb.components.cards
  (:require
   [api.stock.leadtime :as ylt]
   [inflections.core :as in]
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.util.date :as ud]
   [ycweb.components.toaster :as toaster]

   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [util.string :as str]
   #?@(:cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtcoerce]]
       :clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtcoerce]])))

(def delivery-window 2)
(def supplier-open-shipdays 10)

(defn cart-action-config [variation]
  (let [{:keys [notavailable freestock sellablestock comingsoon historicalsales price dateexpected expectedmessage
                datestocklanding closedstart closedend sellablestockstate dateadded]} variation
        now (/ (ud/millis (dt/now)) 1000)
        dateadded (when dateadded (ud/from-php-date dateadded))
        datestocklanding (when datestocklanding (ud/coerce-date datestocklanding))
        lookup-map
        (when variation
          {:supplier_status
           (case notavailable 0 :available 1 :not-available :discontinued)

           :our_stock_status
           (cond
             (pos? (or freestock 0))
             :freestock
             (pos? (or sellablestock 0))
             :sellablestock
             :else
             :nostock)

           :coming_soon_checked (pos? (or comingsoon 0))
           :historical_sales (pos? (or historicalsales 0))
           :retail_price_set (pos? (or price 0))
           :expected_date_and_message
           (and (> (or dateexpected 0) now) (not (str/blank? expectedmessage)))
           :stock_landingdate_set
           (and datestocklanding (dt/after? datestocklanding (dt/minus datestocklanding (dt/days 5))))
           :supplier_closed
           (when (and closedstart closedend)
             (< closedstart now closedend))
           :sellable
           (or (pos? (or sellablestock 0)) (and (= notavailable 0) (= sellablestockstate "Supplier Available")))
           :recentlyadded
           (and dateadded (dt/after? dateadded (dt/minus (dt/now) (dt/years 1))))})]
    (or lookup-map
      {})))

(defn show-price? [{:keys [retail_price_set] :as conf}]
  retail_price_set)

(defn show-add-to-cart? [{:keys [retail_price_set sellable] :as conf}]
  (and retail_price_set sellable))

(defn show-add-to-registry? [{:keys [retail_price_set supplier_status] :as conf}]
  (and retail_price_set (not= supplier_status :discontinued)))

(defn show-add-to-wishlist? [{:keys [supplier_status sellable] :as conf}]
  (or sellable (not= supplier_status :discontinued)))

(defn show-add-notify? [{:keys [retail_price_set sellable supplier_status] :as conf}]
  (and (or (not sellable) (not retail_price_set)) (not= supplier_status :discontinued)))

(defn show-new-product?
  [{:keys [coming_soon_checked historical_sales retail_price_set sellable supplier_status] :as conf}]
  (and
    (not= supplier_status :discontinued)
    (or
      (and
        coming_soon_checked
        (not historical_sales)
        (not sellable))
      (and
        sellable
        (not retail_price_set)))))

(defn show-message-available?
  [{:keys [sellable supplier_status our_stock_status retail_price_set stock_landingdate_set supplier_closed] :as conf}]
  (and
    (or
      (= our_stock_status :nostock)
      (and
        (= our_stock_status :sellablestock)
        (not stock_landingdate_set)))
    (= supplier_status :available)
    sellable
    (not supplier_closed)
    retail_price_set))

(defn show-message-available-presale?
  [{:keys [sellable supplier_status our_stock_status retail_price_set stock_landingdate_set] :as conf}]
  (and
    (or
      (= supplier_status :available)
      (= our_stock_status :sellablestock))
    (= our_stock_status :sellablestock)
    stock_landingdate_set
    sellable
    retail_price_set))

(defn show-message-immediately? [{:keys [sellable supplier_status our_stock_status retail_price_set supplier_closed] :as conf}]
  (and (= supplier_status :available) (= our_stock_status :freestock) sellable retail_price_set (not supplier_closed)))

(defn show-message-limited-immediately? [{:keys [sellable supplier_status our_stock_status retail_price_set supplier_closed] :as conf}]
  (and
    (or
      (not= supplier_status :available)
      supplier_closed)
    (= our_stock_status :freestock)
    sellable
    retail_price_set))

(defn show-message-new-product? [{:keys [recentlyadded sellable historical_sales retail_price_set] :as conf}]
  (and
    (or
      (not sellable)
      (not retail_price_set))
    (not historical_sales)
    recentlyadded))

(defn show-message-tba-price?
  [{:keys [sellable supplier_status our_stock_status coming_soon_checked historical_sales
           retail_price_set expected_date_and_message supplier_closed] :as conf}]
  ;This case is verbose to match exactly, it clashes with 'Not Available' but keeping it like for like with old method.
  ; Could probably be dropped and replaced with 'Not Available'
  (or
    (and
      (= supplier_status :available)
      (= our_stock_status :freestock)
      sellable
      (not coming_soon_checked)
      historical_sales
      (not retail_price_set)
      (not expected_date_and_message)
      supplier_closed)
    (and
      (= supplier_status :not-available)
      (= our_stock_status :nostock)
      (not sellable)
      (not coming_soon_checked)
      (not historical_sales)
      (not retail_price_set)
      (not expected_date_and_message)
      supplier_closed)))

(defn show-message-not-available?
  [{:keys [sellable coming_soon_checked retail_price_set expected_date_and_message] :as conf}]
  (and
    (or
      (not sellable)
      (not retail_price_set))
    (not expected_date_and_message)
    (not coming_soon_checked)))

(defn show-message-not-available-expected?
  [{:keys [sellable coming_soon_checked retail_price_set expected_date_and_message] :as conf}]
  (and
    (or
      (not sellable)
      (not retail_price_set))
    expected_date_and_message
    (not coming_soon_checked)))

(defn show-message-supplier-closed? [{:keys [supplier_status our_stock_status supplier_closed] :as conf}]
  (and
    (= supplier_status :available)
    (not= our_stock_status :freestock)
    supplier_closed))

(defn show-message-tba-fallback? [{:keys [coming_soon_checked retail_price_set] :as conf}]
  ;This case will likely never be hit as it clashes with 'Not Available' above
  (and
    (not retail_price_set)
    (not coming_soon_checked)))

(defn show-message-not-available-fallback?
  [{:keys [sellable supplier_status our_stock_status coming_soon_checked historical_sales
           retail_price_set expected_date_and_message] :as conf}]
  ;This case is verbose to match exactly, odd that they are marked as coming soon and don't meet new product criteria,
  ; again matching verbosely to catch them
  (and
    (= supplier_status :available)
    (= our_stock_status :nostock)
    (not sellable)
    coming_soon_checked
    historical_sales
    retail_price_set
    (not expected_date_and_message)))

(defn show-message [conf]
  (cond
    (show-message-available? conf) :msg-available
    (show-message-available-presale? conf) :msg-available-presale
    (show-message-immediately? conf) :msg-immediately
    (show-message-limited-immediately? conf) :msg-limited-immediately
    (show-message-new-product? conf) :msg-new-product
    (show-message-tba-price? conf) :msg-tba-price
    (show-message-not-available? conf) :msg-not-available
    (show-message-not-available-expected? conf) :msg-not-available-expected
    (show-message-supplier-closed? conf) :msg-supplier-closed
    (show-message-tba-fallback? conf) :msg-tba-price
    (show-message-not-available-fallback? conf) :msg-not-available))

(defn variation-action [i]
  (let [config (cart-action-config i)
        result
        {:show_price (show-price? config)
         :show_add_to_cart (show-add-to-cart? config)
         :show_add_to_registry (show-add-to-registry? config)
         :show_add_to_wish_list (show-add-to-wishlist? config)
         :show_notify (show-add-notify? config)
         :show_new_product (show-new-product? config)
         :show_message (show-message config)}]
    result))

(defn qty-message [variation stockqty]
  (str
    (cond
      (> stockqty 10) " In"
      (> (:selling_packsize variation) 1)
      (str " "
        stockqty " "
        (in/pluralize stockqty (:packdescription variation))
        " in")
      :else
      (str " " stockqty " in"))))

(defn format-arrivaldate [epoch-date]
  (let [months
        ["January" "February" "March" "April" "May" "June"
         "July" "August" "September" "October" "November" "December"]

        date (dtcoerce/from-long epoch-date)
        day (dt/day date)
        month (dt/month date)]
    (str
      (cond
        (< day 10) "early"
        (< day 20) "mid"
        :else "end")
      " "
      (nth months (- month 1)))))

(defn instock-status-message [variation {:keys [show_message] :as actions}]
  (let [stockqty (:freestock variation)
        is-dropship? (boolean (#{"dropship" "dropship_collect"} (:variation-delivery variation)))

        ships-from
        (if is-dropship?
          "directly from supplier"
          "from us")

        leadtime
        (if is-dropship?
          (or (:committeddropshipleadtime variation) (:avgdeliverydays variation))
          (:avgdeliverydays variation))]
    (cond
      ;; No message for non-physical stock.
      (contains? #{"None" "None+Message" "Digital"} (:variation-delivery variation))
      nil

      (= :msg-available show_message)
      {:type :available-stock
       :message
       (if
         (and (pos? leadtime)
           (zero? (:notavailable variation))
           (zero? stockqty))
         (if (ylt/weeks? leadtime)
           (str "Ships " ships-from " in " (ylt/weeks-range leadtime (ylt/max-days leadtime)))
           (str "Available from supplier, ships " ships-from " in "
             (ylt/range-text leadtime (ylt/max-days leadtime) "days")))
         "In stock, ships within 2 to 3 days")
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-available-presale show_message)
      {:type :available-presale
       :message
       (str
         "New stock landing "
         (format-arrivaldate (ud/php-timestamp (:datestocklanding variation))))
       :description "Pre-order this item and you'll be first in line to get yours once the stock arrives."
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-not-available show_message)
      {:type :out-of-stock
       :message "Awaiting Stock"
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-not-available-expected show_message)
      {:type :out-of-stock
       :message "Awaiting Stock"
       :description (:expectedmessage variation)
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-limited-immediately show_message)
      {:type :in-stock
       :message (str (qty-message variation stockqty) " stock, can ship immediately")
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-immediately show_message)
      {:type :in-stock
       :message
       (if
         (and (zero? (:notavailable variation))
           (< 0 stockqty 4))
         (str (qty-message variation stockqty) " stock, can ship immediately. More will take"
           (if (pos? leadtime)
             (str " " leadtime " to "
               (+ delivery-window leadtime) " days")
             (str " up to " delivery-window " days")))
         "In stock, can ship immediately")
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-supplier-closed show_message)
      {:type :available-stock
       :message
       (str "Ships "
         (format-arrivaldate
           (* 1000 (+ (* 86400 supplier-open-shipdays) (:closedend variation)))))
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-tba-price show_message)
      {:type :out-of-stock
       :message "Price to be announced"
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime}

      (= :msg-new-product show_message)
      {:type :out-of-stock
       :message "New product! Coming soon."
       :description ""
       :icon nil
       :class "stock"
       :dropship is-dropship?
       :leadtime leadtime})))

(defn instock-status
  [prefix variation {:keys [show_message] :as actions}]
  (let [message
        (instock-status-message variation actions)]
    (feedback/feedback (:type message) (str prefix ": " (:message message)) (:description message) nil (:class message))))

(rum/defc product-card < rum/static
  [{:keys [options-fn notify-fn addcart-fn delivery-fn show-barcode? hide-price? show-perishable? stocktake-preview? hide-options?]}
   {:keys [price pricewas brand size colour specialshort perishable barcode
           awaitingstock image shopstock bundleup_stickername keepaside_needed keepaside_progress on-click
           ratio_special_free_qty_i ratio_special_ratio_qty_i ratio_special_i] :as solr-product}]
  (let [price (u/parseFloat (or price 0)) pricewas (u/parseFloat (or pricewas 0))
        save? (and pricewas (pos? pricewas) (> pricewas price))
        ratio-special-ratio-qty (u/parseInt ratio_special_ratio_qty_i)
        ratio-special-free-qty (u/parseInt ratio_special_free_qty_i)
        {:keys [show_message] :as actions} (variation-action solr-product)
        out-of-stock (or (= :msg-not-available show_message) (= :msg-not-available-expected show_message))
        packsize (if (> (u/parseInt (:display_packsize solr-product)) 1)
                   (str (:packdescription solr-product) " of " (:display_packsize solr-product))
                   nil)
        delivery-only? (and delivery-fn (= shopstock 0))]
    [:article.card
     {:class
      (u/bem :product-card
        [(cond
           (and
             (not stocktake-preview?)
             out-of-stock)
           :out-of-stock

           (= keepaside_progress :claimed)
           :is-disabled)])

      :on-click on-click}
     [:figure.product-card__hero
      [:img.product-card__image
       {:src (u/cloudinary (:public_id image) {:border-spec (:padding image) :w 128 :h 128}) :alt ""}]
      (when-not stocktake-preview?
        (when out-of-stock [:span {:class (u/bem :pill [:error] :product-card__pill [:stock])} "Awaiting Stock"]))

      (cond
        (and ratio_special_i (pos? ratio-special-ratio-qty) (pos? ratio-special-free-qty))
        [:span.product-card__pill
         {:class (u/bem :pill [:save])}
         ratio-special-ratio-qty " for " (- ratio-special-ratio-qty ratio-special-free-qty) " special"]

        save?
        [:span.product-card__pill {:class (u/bem :pill [:save])} "Save"]

        (u/presence specialshort)
        [:span.product-card__pill {:class (u/bem :pill [:save])} specialshort])

      (when packsize [:span {:class (u/bem :pill [:pack-size] :product-card__pill [:pack-size])} packsize])]
     [:div.product-card__content
      [:h1.product-card__title
       [:span.product-card__brand brand]
       [:span.product-card__name
        (if stocktake-preview?
          (:title solr-product)
          (if (> (count (:title solr-product)) 38)
            (str (subs (:title solr-product) 0 38) "…")
            (:title solr-product)))]
       [:span.u-hidden-from-view "|"]
       [:span.product-card__variation
        (:feature solr-product)]]
      (when show-barcode?
        [:div.product-card__barcode "Barcode: " [:b barcode]])
      (when (and perishable show-perishable?)
        [:div.product-card__footnote
         [:span
          {:class (u/bem :pill [:important])}
          "Perishable Item"]])
      (when-not hide-price?
        (if save?
          [:div.product-card__price
           [:span.product-card__now-price "R" (u/number-format price 0 "." ",")]
           [:span.u-pipe "|"]
           [:span.product-card__was-price "R" (u/number-format pricewas 0 "." ",")]]
          [:div.product-card__price
           [:span "R" (u/number-format price 0 "." ",")]]))
      ;; TODO: this is where these pills sit in the card structure. Might not be ideal?
      (cond
        (= keepaside_progress :inprogress)
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:success])} "In progress"]]

        (= keepaside_progress :claimed)
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:warning])} "Claimed"]]

        (and keepaside_needed (= keepaside_progress "Ready"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:success])} (str keepaside_needed " Ready")]]

        (and keepaside_needed (= keepaside_progress "Can't find"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:error])} (str keepaside_needed " Can't find")]]

        keepaside_needed
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:black])} keepaside_needed]])]

     (when-not hide-options?
       [:nav.product-card__options
        (when options-fn
          (buttons/button [:span.u-hidden-from-view "More Options"]
            (when options-fn #(options-fn solr-product))
            {:secondary true
             :icon-only :dots-menu
             :class :product-card__button}))

        (if out-of-stock
          (buttons/button [:span.u-hidden-from-view "Awaiting Stock"]
            (when notify-fn #(notify-fn solr-product))
            {:secondary true
             :icon-only [:clock :3-3]
             :class :product-card__add-to-cart-button})
          (when addcart-fn
            (buttons/button [:span.u-hidden-from-view "Add to Cart"]
              (if delivery-only? #(delivery-fn solr-product) #(addcart-fn solr-product))
              {:secondary true
               :icon-only (if delivery-only? :truck :cart)
               :class :product-card__add-to-cart-button})))])]))

(rum/defc keepaside-item-card < rum/static
  [{:keys [options-fn hide-options?]}
   {:keys [brand image keepaside_needed keepaside_progress on-click] :as solr-product}]
  (let [packsize
        (if (> (u/parseInt (:display_packsize solr-product)) 1)
          (str (:packdescription solr-product) " of " (:display_packsize solr-product))
          nil)]
    [:article.card.product-card
     {:on-click on-click}
     [:figure.product-card__hero
      [:img.product-card__image
       {:src (u/cloudinary (:public_id image) {:border-spec (:padding image) :w 128 :h 128}) :alt ""}]

      (when packsize [:span {:class (u/bem :pill [:pack-size] :product-card__pill [:pack-size])} packsize])]
     [:div.product-card__content
      [:h1.product-card__title
       [:span.product-card__brand brand]
       [:span.product-card__name
        (if (> (count (:title solr-product)) 38)
          (str (subs (:title solr-product) 0 38) "…")
          (:title solr-product))]
       [:span.u-hidden-from-view "|"]
       [:span.product-card__variation
        (:feature solr-product)]]

      (cond
        (= keepaside_progress :inprogress)
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:success])} "In progress"]]

        (= keepaside_progress :claimed)
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:warning])} "Claimed"]]

        (and keepaside_needed (= keepaside_progress "Placed"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:warning])} (str keepaside_needed " Placed")]]

        (and keepaside_needed (= keepaside_progress "Ready"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:success])} (str keepaside_needed " Ready")]]

        (and keepaside_needed (= keepaside_progress "Missing"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:error])} (str keepaside_needed " Missing")]]

        (and keepaside_needed (= keepaside_progress "Cancelled"))
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:grey])} (str keepaside_needed " Cancelled")]]

        keepaside_needed
        [:div.product-card__footnote
         [:span {:class (u/bem :pill [:black])} keepaside_needed]])]

     (when-not hide-options?
       [:nav.product-card__options
        (when options-fn
          (buttons/button [:span.u-hidden-from-view "More Options"]
            (when options-fn #(options-fn solr-product))
            {:secondary true
             :icon-only :dots-menu
             :class :product-card__button}))])]))

(defn star-rounding [rating]
  (max 0 (min 50 (* (Math/round (float (* rating 2))) 5))))

(defn product-price
  [{:keys [price pricewas] :as product}]
  (let [save? (and pricewas (pos? pricewas) (> pricewas price))]
    [:li.modal__product-price
     (concat
       [[:span "Unit: "
         [:b {:class [(when save? "u-text-status-discount")]}
          "R" (u/number-format price 0 "." ",")]]]
       (when save?
         [[:span.u-hidden-from-view "|"]
          [:span.modal__product-was-price
           "R" (u/number-format pricewas 0 "." ",")]]))]))

(defn product-variation [{:keys [display_packsize packdescription] :as product} {:keys [show-packsize hide-feature] :as opts}]
  (let [packsize
        (when (> (u/parseInt display_packsize) 1)
          (str packdescription " of " display_packsize))]
    [:li.modal__product-variation
     (when-not hide-feature (:feature product))
     (when (and show-packsize packsize) [:span.u-text-status-important packsize])]))

(rum/defc product-infoblock < rum/static
  [{:keys [price brand numreviews
           stockmessage rating pricewas shopstock display_packsize packdescription] :as product} & [show-packsize]]

  [:header.modal__product-info
   [:h2.modal__product-title
    [:span.modal__product-brand brand]
    (if brand
      (str/replace (:title product) brand "")
      (:title product))]

   [:ul.modal__product-details
    (product-variation product {:show-packsize show-packsize})
    (product-price product)]])

;; ========= Notify me Modal ===========================

(rum/defc notify-me-modal-body < rum/reactive [app-atom config-atom]
  (let [product (cmn/curact config-atom :item)
        actions (variation-action product)]
    [(product-infoblock product)
     (instock-status "Website" product actions)

     [:div.u-hr]
     (forms/input "Email Address:" "e.g. jane.smith@domain.com"
       (rum/cursor config-atom :email)
       {:type :email :auto-focus (cmn/auto-focus? app-atom)})]))

(rum/defc notify-me-modal-footer < rum/reactive [app-atom config-atom]
  (let [email (cmn/curact config-atom :email)]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/dispatch-modal-action app-atom :sell/notify-me-cancel)
       :left-no-icon true
       :right-text "Notify Me"
       :right-fn #(grid/dispatch-modal-action app-atom :sell/notify-me)
       :right-no-icon true
       :right-disabled? (if (u/presence email) false true)})))

(defmethod grid/modal-config :sell/notify-me-modal [_ _ _]
  {:body notify-me-modal-body
   :footer notify-me-modal-footer
   :modal-type :alert})

(defn notify-me-modal
  [app-atom product]
  (grid/open-modal app-atom :sell/notify-me-modal {:item product :email ""}))

(defmethod grid/action :sell/notify-me [app-atom config _]
  (toaster/open-toast app-atom :processing "Processing" {})
  (comms/send :pos/notify-me config))

(defmethod comms/receive :pos/notify-me [app-atom e]
  (toaster/open-toast app-atom :success "Success" {})
  (swap! app-atom dissoc :notify-me))

;; ========= Product Info Modal ===========================

(defn product-stores-modal
  [app-atom config]
  (grid/dispatch-action app-atom :product/stores-info-modal config))

(rum/defc product-info-modal-body < rum/reactive [app-atom config-atom]
  (let [{:keys [product] :as modal-config} (rum/react config-atom)
        warehouse-atom (rum/cursor app-atom :selected-warehouse)
        {:keys [price brand productname variationdesc freestock numratings specialshort specs shopstock warehousestock
                storeplans stockmessage pricewas avgrating image packdescription display_packsize bundleup_stickername
                store keptaside ratio_special_free_qty_i ratio_special_ratio_qty_i ratio_special_i]} product

        price (u/parseFloat (or price 0)) pricewas (u/parseFloat (or pricewas 0))
        save? (and pricewas (pos? pricewas) (> pricewas price))

        ratio-special-ratio-qty (u/parseInt ratio_special_ratio_qty_i)
        ratio-special-free-qty (u/parseInt ratio_special_free_qty_i)
        packsize
        (when (> (u/parseInt display_packsize) 1)
          (str packdescription " of " display_packsize))
        warehouse (rum/react warehouse-atom)
        locations (get storeplans (:store-id warehouse))
        location-string (if locations (str "Locations: " locations) "")

        {:keys [show_message] :as actions} (variation-action product)
        out-of-stock (or (= :msg-not-available show_message) (= :msg-not-available-expected show_message))

        shop-stock-available (- shopstock keptaside)]
    [[:div.modal__product-image
      [:img
       {:class (u/bem :image [:full])
        :src (u/cloudinary (:public_id image) {:c "lpad"}) :alt ""}]

      (when out-of-stock
        [:span.modal__product-pill {:class (u/bem :pill [:error])} "Awaiting Stock"])

      (cond
        (and ratio_special_i (pos? ratio-special-ratio-qty) (pos? ratio-special-free-qty))
        [:span.modal__product-pill
         {:class (u/bem :pill [:save])}
         ratio-special-ratio-qty " for " (- ratio-special-ratio-qty ratio-special-free-qty) " special"]

        save?
        [:span.modal__product-pill {:class (u/bem :pill [:save])} "Save"]

        (u/presence specialshort)
        [:span.modal__product-pill {:class (u/bem :pill [:save])} specialshort])

      (when packsize [:span {:class (u/bem :pill [:pack-size] :modal__product-pill [:pack-size])} packsize])]

     (product-infoblock product)

     (if (> shop-stock-available 0)
       (feedback/feedback :in-stock (str (:displayname warehouse) ": " shop-stock-available " in store") location-string nil "stock")
       (feedback/feedback :out-of-stock (str (cmn/curact warehouse-atom :displayname) ": Not in store") location-string nil "stock"))

     (when (pos? warehousestock)
       [[:div.modal__stock-button-wrapper
         (buttons/button "Move Request"
           #(grid/dispatch-modal-action app-atom :sell/send-movement-req)
           {:small true :raised true :secondary true :icon-right :download :icon-size :2-1})]])

     (instock-status "Website" product actions)

     (grid/row {:flush? true :pull-lr? true}
       (grid/cell {:span 1 :cols 2}
         (buttons/button "Check Stores"
           #(product-stores-modal app-atom (assoc product :selected-variation (:vid product)))
           {:small true :raised true :full true :secondary :true :icon-left :help :bordered true}))
       (grid/cell {:span 1 :cols 2}
         (buttons/button "Check Variations"
           #(product-stores-modal app-atom product)
           {:small true :raised true :full true :secondary :true :bordered true})))

     [:div.u-hr]
     [:div.text-content
      (when (and avgrating (pos? avgrating))
        [:p.paragraph
         [:span {:class (u/bem :star-rating [(keyword (str (star-rounding avgrating))) :standard :inline :in-copy-left])}]
         [:b " From " (in/pluralize numratings "Customer Review")]])
      [:div {:dangerouslySetInnerHTML {:__html specs}}]]]))

(rum/defc product-info-modal-footer < rum/reactive [app-atom config-atom]
  (let [{:keys [product footer-close remove-footer]} (rum/react config-atom)]
    (cond
      footer-close
      (grid/button-row
        {:single-text "Close"
         :single-fn #(grid/dispatch-modal-action app-atom :sell/product-info-close)
         :single-style :secondary})

      remove-footer
      nil

      :else
      (let [{:keys
             [price brand productname variationdesc freestock numratings specialshort specs shopstock
              stockmessage pricewas avgrating image packdescription display_packsize] :as product}
            (cmn/curval product)

            {:keys [show_message] :as actions} (variation-action product)
            out-of-stock (or (= :msg-not-available show_message) (= :msg-not-available-expected show_message))]
        (if out-of-stock
          (grid/button-row
            {:single-text "Notify Me"
             :single-fn #(notify-me-modal app-atom product)})

          (grid/button-row
            {:left-text "Deliver"
             :left-style :secondary
             :left-fn #(grid/dispatch-modal-action app-atom :sell/product-info-deliver)
             :right-text "Add to Cart"
             :right-fn #(grid/dispatch-modal-action app-atom :sell/product-info-addcart)
             :right-disabled? (= 0 shopstock)}))))))

(defmethod grid/modal-config :cards/product-info-modal [_ _ _]
  {:body product-info-modal-body
   :footer product-info-modal-footer})

(defmethod grid/modal-config :cards/product-info-modal-no-footer [_ _ _]
  {:body product-info-modal-body})

(defn product-info-modal
  [app-atom {:keys [footer-close remove-footer] :as config} product]
  (when product
    (grid/open-modal app-atom
      (if remove-footer :cards/product-info-modal-no-footer :cards/product-info-modal)
      (assoc config :product product))))

(rum/defc product-stores-info-modal-body < rum/reactive [app-atom config-atom]
  (let [warehouse-list (cmn/curact app-atom [:warehouse-list])
        stores-info-atom (rum/cursor-in app-atom [:product/stores-info])
        stores-info (rum/react stores-info-atom)

        {:keys [product stores-loading]
         {:keys [product-variations vid-lid-shopstock]} :stores-info}
        stores-info

        selected-vid (:selected-variation product)

        indexed-product-variations
        (u/index-by :id product-variations)

        selected-variation (get indexed-product-variations selected-vid)

        variation-options
        (->>
          product-variations
          (map
            (fn [{:keys [id feature qty-available]}]
              {:value id
               :text (str feature (when (pos? qty-available) (str " (" qty-available ")")))})))

        stores-data
        (when selected-variation
          (map
            (fn [w]
              (assoc w
                :shopstock
                (get-in vid-lid-shopstock [(:id selected-variation) (:warehouse-id w) :shopstock] 0)))
            warehouse-list))]

    [[:header.modal__product-info
      [:h2.heading "Check All Store Stock"]
      [:h3.modal__product-title
       [:span.modal__product-brand (:brand product)]
       (:title product)]

      [:ul.modal__product-details
       (product-variation product {:hide-feature true})
       (product-price
         (assoc product
           :price (-> (:price selected-variation) (/ 100))
           :pricewas (-> (:pricewas selected-variation) (/ 100))))]]

     (when-not stores-loading
       (forms/select "Choose variation:"
         (rum/cursor-in stores-info-atom [:product :selected-variation])
         (into [{:value 0 :text "Please Select"}] variation-options)
         {:type :number}))

     (grid/tabular-list
       (map
         (fn [{:keys [displayname shopstock] :as w}]
           (let [shopstock (get-in vid-lid-shopstock [(:id selected-variation) (:warehouse-id w) :shopstock] 0)]
             {:name displayname
              :value shopstock
              :icon-modifiers
              [(if (pos? shopstock) :in-stock :out-of-stock)]}))
         warehouse-list))

     (instock-status "Website" product (variation-action product))]))

(rum/defc product-stores-info-modal-footer < rum/reactive [app-atom config-atom]
  (let [stores-info-atom (rum/cursor-in app-atom [:product/stores-info])
        stores-info (rum/react stores-info-atom)]
    (grid/button-row
      {:left-fn #(product-info-modal app-atom {:remove-footer true} (:product stores-info))
       :right-text "View Details"
       :right-fn
       (fn []
         (comms/send :pos/querybarcode
           {:session-uuid (:session-uuid @app-atom)
            :barcode
            (->
              (get
                (u/index-by :id (-> stores-info :stores-info :product-variations))
                (:selected-variation @config-atom))
              (get :barcode))}))
       :right-style :secondary
       :right-no-icon true})))

(defmethod grid/modal-config :product/stores-info-modal [_ _ _]
  {:body product-stores-info-modal-body
   :footer product-stores-info-modal-footer})

(defmethod grid/action :product/stores-info-modal [app-atom config _]
  (swap! app-atom assoc :product/stores-info {:product config :stores-loading true :stores-info {}})
  (comms/send :product/stores-info {:product-id (:pid config)})
  (toaster/open-toast app-atom :processing "Loading" {})
  (grid/open-modal app-atom :product/stores-info-modal config))

(defmethod comms/receive :product/stores-info [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom update :product/stores-info
    (fn [{:keys [product] :as s}]
      ;; Make sure the response is actually for the correct product still.
      (if (= (:pid product) (:product-id e))
        (assoc s
          :stores-info e
          :stores-loading false)
        s))))

(rum/defc product-slat < rum/static
  [{:keys [options-fn option-icon option-limited hide-qty show-barcode? show-perishable? hide-price?
           background-color pending?]}
   {:keys [qty thumbnail price pricewas brand size colour specialshort pulse-slat
           awaitingstock adjusted-from specialadded specialgroupnumber comments
           bundleup_ratioqty bundleup_freeqty perishable barcode ycr-item
           registry_contentname registry_brandname] :as solr-product}]
  (let [save? (and pricewas (pos? pricewas) (> pricewas price))
        bundle-discount-line? (and specialgroupnumber (< price 0) comments)
        special-bundle? (when (> bundleup_ratioqty 0) (> bundleup_freeqty 0))
        bundle-description (when special-bundle? (str bundleup_ratioqty " for " (- bundleup_ratioqty bundleup_freeqty) " Special"))
        brand_name (if registry_brandname "Registry Purchase" brand)
        product_name (or registry_contentname (:title solr-product))]
    [:article.slat
     {:on-click (when-not option-limited #(when (and options-fn (not bundle-discount-line?)) (options-fn solr-product)))
      :class (u/bem :product-slat [(case pulse-slat :add :pulse-plus :remove :pulse-minus nil) (when pending? :pulse-pending)])
      :style
      {:background-color
       (cond
         background-color background-color
         (and adjusted-from (not= price adjusted-from)) "red")}}
     (when (not hide-qty) [:div.product-slat__qty [:span (or qty 1)]])
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        (if bundle-discount-line?
          [:h1.product-slat__title
           [:b.u-text-status-discount "Bundle discount"] " - " comments]
          [:h1.product-slat__title
           [:span.product-slat__brand brand_name]
           product_name])
        (when bundle-description
          [:div.product-slat__pill-wrapper
           [:span
            {:class (u/bem :pill [:discount])} bundle-description]])
        (when ycr-item
          [:div.product-slat__pill-wrapper
           [:span
            {:class (u/bem :pill [:discount])} ycr-item]])]
       (when (and options-fn (not bundle-discount-line?))
         [:div.product-slat__option
          (buttons/button ""
            #(when options-fn (options-fn solr-product))
            {:secondary true
             :icon-only (or option-icon :dots-menu)
             :class :product-card__more-button})])]
      [:ul.product-slat__details
       (let [features
             (u/glue ", " (:feature solr-product)
               (when (and (:display_packsize solr-product) (> (:display_packsize solr-product) 1))
                 (str (:packdescription solr-product) " of " (:display_packsize solr-product))))]
         (when-not (str/blank? features)
           [:li.product-slat__variation features]))
       (when (or (= (:code solr-product) "Voucher") show-barcode?)
         [:li.product-slat__barcode [:b.u-barcode barcode]])
       (when-not hide-price?
         (if save?
           [:li.product-slat__price
            [:div [:span (if bundle-discount-line? "Discount: " "Unit: ")] [:b.u-text-status-discount "R" (u/number-format price)]]
            [:span.u-hidden-from-view "|"]
            [:div.product-slat__was-price "Was: R" (u/number-format pricewas)]]
           [:li.product-slat__price
            [:div
             [:span (if bundle-discount-line? "Discount: " "Unit: ")]
             [:b (when specialadded {:class :u-text-status-discount})
              (if (and specialadded (= 0 price)) "Free" (str "R" (u/number-format price)))]]]))]
      (when (and show-perishable? perishable)
        [:div.product-slat__pill-wrapper
         [:span {:class (u/bem :pill [:important])} "Perishable Item"]])]]))
